import React from 'react';
import coinbase from './assets/coinbase.png';
import logo from './assets/logo.png';
import farcaster from './assets/farcaster.png';

import doppler from './assets/doppler.png';
import dots from './assets/dots.png';
import uniswap from './assets/uniswap.png';

import clayToken from './assets/clayToken.png';
import ripsIcon from './assets/ripsIcon.png';
import duelsLogo from './assets/duelsLogo.png';

import xIcon from './assets/xIcon.png';
import farIcon from './assets/farIcon.png';

import './App.css';

function App () {
  return (
    <div className="flex flex-col items-center justify-center bg-black text-white p-4 rounded">

      {/* <img src={logo} className="w-[172px] h-[170px] mt-12" alt="logo" /> */}
      <div className='flex flex-row items-center justify-center  mt-12'>
        <img src={logo} className="w-[32px] h-[32px]" alt="logo" width={32} height={32} />
        <p className="pl-2 text-center text-white w-full text-[35px] font-bold max-w-[682px] leading-[50px]">
          Creative Layer
        </p>
      </div>
      <p className="text-center text-white w-full text-[50px] md:text-[100px] font-bold max-w-[1121px] mt-12 leading-[50px] md:leading-[110px]">
        The launchpad for onchain mini-apps
      </p>

      <p className="text-center text-[#8395A7] w-full text-[30px] font-normal max-w-[885px] mt-12 leading-[40px]">
        Build. Play. Collect. Connect. Create mini-apps using tokenized content with built-in community mechanics.
      </p>

      <p className="text-center text-white text-[40px] md:text-[80px] font-bold mt-20">
        $CLAY Token
      </p>

      <div className='relative mt-20 flex flex-col w-full max-w-[1209px] items-start justify-center gap-4'>

        <button disabled className='flex flex-row items-start justify-start bg-[#536B7C40]  w-full h-[150px] md:h-[282px] rounded-3xl p-8 md:p-14'>
          <div className='flex flex-col items-center justify-center h-full'>
            <img src={clayToken} className="h-auto object-contain " alt="rips" width={220} height={220} />
          </div>
          <div className='flex flex-col items-center justify-center h-full w-full'>
            <p className="text-start w-full text-white text-[26px] md:text-[34px] leading-6 font-normal pl-4 md:pl-8">
              $CLAY
            </p>
            <p className="text-start w-full text-[#92A7BC] text-[12px] md:text-[25px] font-normal pl-4 md:pl-8">
              Coming soon...
            </p>
          </div>

          {/* <div className='flex flex-col items-center justify-center h-full'>
            <div className='flex flex-row items-center justify-center  rounded-full h-[70px] md:h-[100px] w-[160px] md:w-[214px] bg-[#536B7C] text-white text-[14px] md:text-[22px] font-medium'>Coming soon</div>
          </div> */}
        </button>
      </div>

      <p className="text-center text-white text-[40px] md:text-[80px] font-bold mt-40">
        Our Apps
      </p>

      <div className='relative mt-20 flex flex-col w-full max-w-[1209px] items-start justify-center gap-4'>
        <div className='flex flex-row items-start justify-start bg-[#536B7C40]  w-full h-[150px] md:h-[282px] rounded-3xl p-8 md:p-14'>
          <div className='flex flex-col items-center justify-center h-full'>
            <img src={ripsIcon} className="h-auto object-contain " alt="rips" width={220} height={220} />
          </div>
          <div className='flex flex-col items-center justify-center h-full w-full'>
            <p className="text-start w-full text-white text-[26px] md:text-[34px] leading-6 font-normal pl-4 md:pl-8">
              RIPS
            </p>
            <p className="text-start w-full text-[#92A7BC] text-[12px] md:text-[25px] font-normal pl-4 md:pl-8">
              Pull mystery coins with every pack 💥
            </p>
          </div>

          <div className='flex flex-col items-center justify-center h-full w-[120px] md:w-[200px]'>
            <div className='flex flex-row items-center justify-center  rounded-full h-[50px] md:h-[100px] w-[120px] md:w-[200px] bg-[#536B7C] text-white text-[12px] md:text-[22px] font-medium'>Coming soon</div>
          </div>
        </div>

        <a href="https://farcaster.xyz/miniapps/j20ZrzExJEXM/duels" target="_blank" rel="noopener noreferrer" className='flex flex-row items-start justify-start bg-[#536B7C40]  w-full h-[150px] md:h-[282px] rounded-3xl p-8 md:p-14 hover:bg-[#536B7C60] transition-all duration-300'>
          <div className='flex flex-col items-center justify-center h-full'>
            <img src={duelsLogo} className="h-auto object-contain " alt="duels" width={220} height={220} />
          </div>
          <div className='flex flex-col items-center justify-center h-full w-full'>
            <p className="text-start w-full text-white text-[26px] md:text-[34px] leading-6 font-normal pl-4 md:pl-8">
              DUELS
            </p>
            <p className="text-start w-full text-[#92A7BC] text-[12px] md:text-[25px] font-normal pl-4 md:pl-8">
              The first prediction market for content ⚡
            </p>
          </div>

          <div className='flex flex-col items-center justify-center h-full min-w-[120px] md:min-w-[200px]'>
            <div className='flex flex-row items-center justify-center h-full gap-4'>
              <a className="max-w-[100px] max-h-[100px]" href="https://farcaster.xyz/miniapps/j20ZrzExJEXM/duels" target="_blank" rel="noopener noreferrer">
                <img src={farcaster} className="h-auto object-contain" alt="farcaster" />
              </a>

              <a className="max-w-[100px] max-h-[100px]" href="https://www.coinbase.com/" target="_blank" rel="noopener noreferrer">
                <img src={coinbase} className="h-auto object-contain" alt="coinbase" />
              </a>
            </div>
          </div>
        </a>
      </div>


      <p className="text-center text-white text-[40px] md:text-[80px] font-bold mt-40">
        Our Partners
      </p>

      <div className='grid grid-cols-5 gap-4 md:gap-10 mt-20'>

        <a className="max-w-[100px] max-h-[100px]" href="https://www.doppler.lol/" target="_blank" rel="noopener noreferrer">
          <img src={doppler} className=" h-auto object-contain" alt="doppler" />
        </a>
        <a className="max-w-[100px] max-h-[100px]" href="https://farcaster.xyz/" target="_blank" rel="noopener noreferrer">
          <img src={farcaster} className="h-auto object-contain" alt="farcaster" />
        </a>

        <a className="max-w-[100px] max-h-[100px]" href="https://www.coinbase.com/" target="_blank" rel="noopener noreferrer">
          <img src={coinbase} className="h-auto object-contain" alt="coinbase" />
        </a>


        <a className="max-w-[100px] max-h-[100px]" href="https://app.uniswap.org/" target="_blank" rel="noopener noreferrer">
          <img src={uniswap} className="h-auto object-contain" alt="uniswap" />
        </a>

        <a className="max-w-[100px] max-h-[100px]" href="https://splits.org/" target="_blank" rel="noopener noreferrer">
          <img src={dots} className="h-auto object-contain" alt="dots" />
        </a>
      </div>

      <p className="text-center text-white text-[40px] md:text-[80px] font-bold mt-40">
        About us
      </p>

      <p className="text-center text-[#8395A7] w-full text-[30px] font-normal max-w-[999px] mt-12 leading-[40px]">
        Creative Layer is a platform for building and launching onchain content apps—that blur the lines between media, games, and markets.
      </p>
      <p className="text-center text-[#8395A7] w-full text-[30px] font-normal max-w-[999px] mt-12 leading-[40px]">
        Each app has its own game loop, and its own culture.
        Behind the scenes, they’re all powered by a shared creator network
        and modular protocol infrastructure.
      </p>

      <div className='grid grid-cols-2 gap-2 my-20'>
        <a href="https://farcaster.xyz/creativelayer" target="_blank" rel="noopener noreferrer">
          <img src={farIcon} className="w-[67px] h-[50px] mt-3" alt="farIcon" />
        </a>
        <a href="https://x.com/_creativelayer" target="_blank" rel="noopener noreferrer">
          <img src={xIcon} className="w-[67px] h-[50px] mt-3" alt="xIcon" />
        </a>
      </div>

      <div className='flex flex-row items-center justify-center border-b-[1px] border-[#9CAFC050] pt-10 w-full' />

      <div className='grid grid-cols-6 w-full'>
        <p className="pl-8 col-span-4 text-start text-white text-[40px] md:text-[80px] font-bold mt-20 max-w-[883px]">
          The launchpad for onchain mini-apps
        </p>
      </div>

      <p className="pl-8 text-start text-white text-[12px] md:text-[16px] font-bold mt-20 pb-8 md:mt-40 w-full">
        2025 Creative Layer
      </p>
    </div>
  );
}

export default App;
